import { booleanAttribute, Component, computed, input, InputSignal, output, OutputEmitterRef, signal, Signal } from '@angular/core';
import { FormControl } from '@angular/forms';

// Basis voor de controls zonder FormControl (app-xxx naast app-xxx-control), voor instellingen die
// direct worden toegepast i.p.v. via een formulier opgeslagen: [value] in, (valueChange) uit,
// ook als [(value)].
//
// De Material-template staat alleen in de app-xxx-control; deze laag geeft die een interne
// FormControl. Die is een pure computed over value/disabled (geen effect dat de control
// schrijft): na een gebruikerswijziging wordt hij opnieuw opgebouwd uit [value]. De ouder blijft
// zo de enige bron: neemt hij de nieuwe waarde over, dan toont de control die; doet hij dat niet
// (bv. eerst een bevestigingsstap), dan springt de control vanzelf terug.
@Component({
    selector: 'app-value-control',
    template: '',
    styleUrls: [],
})
export abstract class _ValueControlComponent<T>
{
    abstract control$$: Signal<FormControl>;
    abstract disabled$$: Signal<boolean>;
    abstract label$$: InputSignal<string>;
    abstract readonly$$: Signal<boolean>;
    abstract value$$: InputSignal<T | null>;

    abstract out_valueChange: OutputEmitterRef<T>;

    protected _input_disabled$$ = input(false,      { transform: booleanAttribute, alias: 'disabled' });
    protected _input_label$$    = input<string>('', { alias: 'label' });
    protected _input_readonly$$ = input(false,      { transform: booleanAttribute, alias: 'readonly' });
    protected _input_value$$    = input<T | null>(null, { alias: 'value' });

    protected _out_valueChange = output<T>({ alias: 'valueChange' });

    // Opgehoogd bij elke gebruikerswijziging, zodat _control$$ opnieuw uit [value] wordt opgebouwd.
    private __revision$$ = signal(0);

    protected _control$$ = computed(() => {
        this.__revision$$();
        return new FormControl({ value: this._controlValue(this._input_value$$()), disabled: this._input_disabled$$() });
    });

    protected _emit_valueChange(value: T): void {
        this._out_valueChange.emit(value);
        this.__revision$$.update(_revision => _revision + 1);
    }

    // Waarde zoals de onderliggende -control hem verwacht; standaard gelijk aan [value]
    // (Select vertaalt hier de itemId naar het lijst-item).
    protected _controlValue(value: T | null): unknown {
        return value;
    }
}
